import './App.css';
import AboutUs from './pages/aboutUs/aboutUs';
import ContactUs from './pages/contactUs/contactUs';
import Landing from './pages/landing/landing';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Solutions from './pages/solutions/solutions';
import PrivacyPolicy from './pages/privacyPolicy/privacyPolicy';
import Pricing from './pages/pricing/pricing';
import Login from './pages/login/Login';
import Signup from './pages/signup/Signup';
import VerificationPage from './pages/signup/verification/verification';


function App() {

  return (
    <BrowserRouter>
      <Routes>
        <Route path={"/"} element={<Landing />} />
        <Route path={"/aboutus"} element={<AboutUs />} />
        <Route path={"/contactus"} element={<ContactUs />} />
        <Route path={"/solutions"} element={<Solutions />} />
        <Route path={"/pricing"} element={<Pricing />} />
        <Route path={"/privacy-policy"} element={<PrivacyPolicy />} />
        <Route path={"/login"} element={<Login />} />
        <Route path={"/signup"} element={<Signup />} />
        <Route path={"/signup/verification"} element={<VerificationPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
